import { DIFFICULTIES, DEFAULT_DIFFICULTY } from "../data/difficulty";

// Player settings (difficulty + accessibility), persisted in localStorage.
export interface Settings {
  difficulty: number; // index into DIFFICULTIES
  screenShake: boolean;
  reduceFlashing: boolean;
}

const KEY = "pckt_settings";

export function loadSettings(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const s = JSON.parse(raw) as Partial<Settings>;
      return {
        difficulty: clampInt(s.difficulty, 0, DIFFICULTIES.length - 1, DEFAULT_DIFFICULTY),
        screenShake: s.screenShake !== false, // default on
        reduceFlashing: s.reduceFlashing === true, // default off
      };
    }
  } catch {
    /* ignore */
  }
  return { difficulty: DEFAULT_DIFFICULTY, screenShake: true, reduceFlashing: false };
}

export function saveSettings(s: Settings): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    /* ignore */
  }
}

function clampInt(v: unknown, lo: number, hi: number, def: number): number {
  const n = typeof v === "number" && Number.isFinite(v) ? Math.round(v) : def;
  return Math.max(lo, Math.min(hi, n));
}
